export const transformDataForReport = (apiData) => {
  if (!apiData || !apiData.familyData) {
    return null;
  }

  const { familyData } = apiData;

  return {
    familyId: familyData.familyId,
    lastUpdated: familyData.lastUpdated,
    parent1: { name: familyData.parentName1 },
    parent2: { name: familyData.parentName2 },
    children: familyData.children.map(child => ({
      id: child.childId,
      name: child.studentName,
      birthdate: child.birthdate,
      sundaySchool: child.sundaySchool,
      russianSchool: child.russianSchool,
      childrensChoir: child.childrensChoir,
      activities: {
        ...(child.sundaySchool && { "Sunday School": child.sundaySchool }),
        ...(child.russianSchool && { "Russian School": child.russianSchool }),
        ...(child.childrensChoir && { "Children's Choir": child.childrensChoir }),
      }
    }))
  };
};
